import styled from "styled-components/macro";

export const ButtonMenuContainer = styled.div`
  --text-color: var(--cta-text-color);
  background-color: var(--primary-cta);
  color: var(--cta-text-color);
  border-radius: 10px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  font-family: "Inter";
  display: flex;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  height: 42px;
  padding-left: 8px;

  .sparkle {
    width: 24px;
    height: 24px;
    path {
      fill: var(--cta-text-color);
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  &.select-only {
    --text-color: var(--primary-cta-high-contrast);
    background-color: var(--menu-color-fullscreen) !important;
    border: 2px solid var(--primary-cta-high-contrast);
    color: var(--text-color);
    padding-left: 0;

    .labels {
      padding: 6px 7px;
      .mode-label {
        font-size: 9px;
      }
    }

    .submenu-control {
      padding: 0 4px;
      border-left: none;
    }
  }

  &.disabled {
    background-color: var(--primary-cta-light);
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }

  .labels {
    flex-grow: 2;
    /* flex-shrink: 0; */
    margin: 0px;
    padding: 9px 8px 9px 6px;
    cursor: pointer;

    .new {
      font-size: 9px;
      background: var(--primary-cta);
      border-radius: 3px;
      padding: 2px 3px;
      color: var(--cta-text-color);
      position: relative;
      top: -1px;
    }

    .action-label {
      font-size: 14.8px;

      p {
        line-height: 1.3 !important;
      }
    }

    .mode-label {
      font-size: 9.5px;
      margin-bottom: 2px;
    }
  }

  .submenu-control {
    display: flex;
    position: relative;
    border-left: 1.5px solid rgba(255, 255, 255, 0.3);
    height: 42px;
    cursor: pointer;
    align-items: center;

    svg {
      padding: 10px;
      path {
        fill: var(--text-color);
      }
      width: 14px;
    }
  }

  .submenu {
    position: absolute;
    left: 0;
    top: 120%;
    background-color: var(--menu-color);
    padding: 10px;
    border-radius: 13.3333px;
    box-shadow: var(--default-drop-shadow);
    width: 100%;
    min-width: 190px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .group {
      max-height: 330px;
      overflow: scroll;

      &.Custom {
        max-height: 200px;
      }
    }

    .group-name {
      padding: 0px 8px 8px 8px;
      color: var(--primary-cta);
      max-width: 120px;
    }

    .item {
      display: flex;
      align-items: center;
      border: 2px solid transparent;
      border-radius: 6.6666px;

      &.active {
        border: 2px solid var(--primary-cta);

        &:hover {
          background-color: var(--menu-color);
        }
      }

      &:hover {
        background-color: var(--menu-color-hover);
      }

      .icon {
        padding: 0 4px 0 6px;

        svg {
          width: 20px;
          height: 20px;

          path {
            stroke: transparent;
            fill: var(--grey-0);
          }
        }
      }

      .labels {
        color: var(--grey-0);

        .mode-label {
          font-size: 14.5px;
        }
        .sub-label {
          white-space: break-spaces;
          line-height: 1.25;
          font-size: 10.5px;
          margin-top: 3px;
        }
      }
    }
  }
`;
